import React from 'react';
import type { ButtonProps } from 'baseui/button';
import { Button, KIND, SHAPE, SIZE as BTN_SIZE } from 'baseui/button';
export const IconButton = (props: ButtonProps & {
  children?: React.ReactNode;
}) => {
  return <Button shape={SHAPE.square} size={BTN_SIZE.xSmall} kind={KIND.tertiary} overrides={{
    BaseButton: {
      style: ({
        $theme
      }) => ({
        width: $theme.sizing.scale850,
        height: $theme.sizing.scale850,
        padding: '0px',
        borderRadius: $theme.borders.radius300,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
      })
    }
  }} {...props}>
      {props.children}
    </Button>;
};